<template>

<div class="actionplan">

	<com-headmain :simple="true" />

	<div class="actionplan-content">

		<div class="actionplan-title">{{ section.patient.title || section.text.title }}<div class="subsection-close" v-on:click="$emit('back')"></div></div>

		<div class="actionplan-intro" v-if="section.intro" v-html="section.intro"></div>

		<div class="actionplan-hcp" v-if="hasHcpSteps">

			<div class="actionplan-section-title">{{ section.hcp_title || 'Your health professional indicated these are the next steps' }}</div>

			<div class="actionplan-hcp-item" v-for="(step, index) in hcpSteps" :key="index">
				<i class="fa-solid fa-check"></i>
				<span>{{ step }}</span>
			</div>

		</div>

		<div class="actionplan-self">

			<div class="actionplan-section-title">{{ section.self_title || 'My actions' }}</div>

			<div class="actionplan-self-intro" v-if="section.self_intro" v-html="section.self_intro"></div>

			<div class="actionplan-goals">

				<div class="actionplan-goal" v-for="goal in activeGoals" :key="goal.key" v-on:click="toggleGoal(goal.key)" :class="{'is-active': isGoalActive(goal.key)}">

					<div class="actionplan-goal-check"><i class="fa-solid fa-check" v-if="isGoalActive(goal.key)"></i></div>

					<span>{{ goal.text }}</span>

				</div>

			</div>

		</div>

		<com-check :text="section.text.title" v-on:click="$emit('next')" />

	</div>

</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comCheck from './common/Check'

export default {

	props: ['section'],

	components: {
		'com-headmain': comHeadMain,
		'com-check': comCheck
	},

	data: function() {

		return {
			goals: []
		}

	},

	computed: {

		activeGoals: function() {

			return this.$_.filter(this.section.goals || [], function(goal) {
				return goal.text
			})

		},

		hasHcpSteps: function() {

			return this.$store.getters['session/patient/mode'] === 'prepopulated' && this.hcpSteps.length > 0

		},

		hcpSteps: function() {

			var steps = []
			var values = this.$store.getters['session/values']

			var medicineOptions = {
				1: 'Consider starting an oral bisphosphonate',
				2: 'Consider starting hormone replacement therapy (HRT)',
				3: 'No drug recommended',
				4: 'Continue with an oral bisphosphonate',
				5: 'Stop current treatment with an oral bisphosphonate',
				6: 'Stop current treatment with an oral bisphosphonate and consider an alternative drug in primary care'
			}

			if (values[100] && medicineOptions[values[100]]) {
				steps.push(medicineOptions[values[100]])
			}

			if (values[101] === 1) steps.push('Onwards referral for opinion or scans')
			if (values[101] === 2) steps.push('No onwards referral')

			var referralFor = values[102]
			if (referralFor && referralFor.length) {
				var opts = { 1: 'Bone density scan', 2: 'Specialist advice and guidance', 3: 'Specialist referral' }
				var items = []
				this.$_.each(referralFor, function(v) { if (opts[v]) items.push(opts[v]) })
				if (items.length) steps.push('Referral for: ' + items.join(', '))
			}

			var nextSteps = values[103] || []
			if (this.$_.contains(nextSteps, 1)) steps.push('No further action needed \u2013 unless any further concerns')
			if (this.$_.contains(nextSteps, 2)) steps.push('Collect prescription for new osteoporosis medicine from pharmacy')

			var awaitItems = values[105] || []
			if (this.$_.contains(nextSteps, 3) && awaitItems.length) {
				var awaitOpts = { 1: 'next appointment', 2: 'hospital appointment', 3: 'physiotherapy appointment', 4: 'blood test' }
				var awaitTexts = []
				this.$_.each(awaitItems, function(v) { if (awaitOpts[v]) awaitTexts.push(awaitOpts[v]) })
				if (awaitTexts.length) steps.push('Await: ' + awaitTexts.join(', '))
			}

			var bookItems = values[106] || []
			if (this.$_.contains(nextSteps, 4) && bookItems.length) {
				var bookOpts = { 1: 'next appointment', 2: 'physiotherapy appointment', 3: 'blood test', 4: 'further contact' }
				var bookTexts = []
				this.$_.each(bookItems, function(v) { if (bookOpts[v]) bookTexts.push(bookOpts[v]) })
				if (bookTexts.length) steps.push('Book: ' + bookTexts.join(', '))
			}

			return steps

		}

	},

	created: function() {

		var saved = this.$cookies.getItem('ifrap_patient_goals')
		this.goals = saved ? JSON.parse(saved) : []

	},

	methods: {

		toggleGoal: function(key) {

			var index = this.goals.indexOf(key)

			if (index >= 0) {
				this.goals.splice(index, 1)
			} else {
				this.goals.push(key)
			}

			this.$cookies.setItem('ifrap_patient_goals', JSON.stringify(this.goals))

		},

		isGoalActive: function(key) {

			return this.goals.indexOf(key) >= 0

		}

	}

}

</script>

<style scoped>

.actionplan {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .actionplan { left: 64px; }
.is-mobile .actionplan { left: 0px; }

.actionplan-content {
	width: 100%;
	max-width: 900px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-mobile .actionplan-content { padding: 80px 15px 85px 15px; }

.actionplan-title {
	font-weight: 100;
	font-size: 36px;
	line-height: 36px;
	letter-spacing: 3px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.actionplan-title:after { content: ' '; position: absolute; bottom: -16px; left: 0px; height: 4px; background-color: var(--aid-color); width: 150px; }

.is-mobile .actionplan-title { font-size: 18px; line-height: 18px; margin-bottom: 32px; }

.actionplan-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; }
.is-mobile .actionplan-intro { font-size: 14px; line-height: 22px; }

.actionplan-section-title {
	font-size: 20px;
	font-weight: 600;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 20px;
}

.is-mobile .actionplan-section-title { font-size: 16px; }

.actionplan-hcp {
	margin-bottom: 40px;
	padding-bottom: 40px;
	border-bottom: 1px solid var(--aid-color);
}

.actionplan-hcp-item {
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	font-size: 16px;
	color: #343434;
	line-height: 24px;
}

.actionplan-hcp-item i {
	color: #4CAF50;
	margin-right: 12px;
	margin-top: 4px;
	flex-shrink: 0;
}

.is-mobile .actionplan-hcp-item { font-size: 14px; }

.actionplan-self { margin-bottom: 32px; }

.actionplan-self-intro {
	font-size: 16px;
	color: #666;
	line-height: 24px;
	margin-bottom: 20px;
}

.actionplan-goals { display: flex; flex-direction: column; }

.actionplan-goal {
	display: flex;
	align-items: center;
	padding: 14px 16px;
	border: 2px solid #e0e0e0;
	border-radius: 12px;
	margin-bottom: 8px;
	cursor: pointer;
	font-size: 16px;
	color: #343434;
	line-height: 22px;
	transition: all 300ms ease-in-out;
}

.actionplan-goal:hover { border-color: var(--aid-color); }

.actionplan-goal.is-active {
	border-color: #343434;
	background-color: #343434;
	color: #fff;
}

.actionplan-goal-check {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	margin-right: 12px;
	border-radius: 4px;
	border: 2px solid #ccc;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: transparent;
	transition: all 300ms ease-in-out;
}

.actionplan-goal:hover .actionplan-goal-check { color: #ccc; }

.actionplan-goal.is-active .actionplan-goal-check {
	border-color: #fff;
	background-color: #343434;
	color: #fff;
}

.is-mobile .actionplan-goal { font-size: 14px; padding: 12px 14px; }

</style>
